import { FiInfo } from "react-icons/fi";
import useFilingClosure from "../hooks/useFilingClosure";

export default function FilingClosureBanner() {
  const filingClosed = useFilingClosure();
  if (filingClosed !== true) return null;

  return (
    <section aria-label="2025 e-filing closure" className="shrink-0 bg-[#FFF3D6] border-b border-[#E8C675] px-4 py-4 md:px-8">
      <div className="max-w-3xl mx-auto flex items-start gap-2.5 md:gap-3">
        <FiInfo aria-hidden="true" className="w-5 h-5 shrink-0 text-[#835614] mt-0.5" />
        <div>
          <p className="font-semibold text-[15px] md:text-base text-[#694509]">E-filing is closed for tax year 2025</p>
          <p className="text-[13px] md:text-sm leading-relaxed text-[#79561E] mt-1">
            Due to unprecedented demand, Prime Meridian is no longer accepting new e-filings for tax year 2025. You can still generate and review your tax return, but we won’t be able to file it for you.
          </p>
        </div>
      </div>
    </section>
  );
}
